import React, { useEffect, useMemo, useState } from 'react';
import { Radio, RadioGroup, FormControlLabel } from '@mui/material';

export interface IRadioGroupItem {
  label: string;
  value: string;
  default: boolean;
}

interface IRadioGroupItemExtended extends IRadioGroupItem {
  id: string;
}

interface IProps {
  options: IRadioGroupItem[];
  onChange: (option: IRadioGroupItem | undefined) => void;
  disabled: boolean;
}

const RadioGroupComponent: React.FC<IProps> = ({ options, onChange, disabled }) => {
  const [selectedOption, setSelectedOption] = useState<IRadioGroupItem | undefined>(options.find(i => i.default));

  const handleSelection = (_: React.ChangeEvent<HTMLInputElement>, value: string): void => {
    const selectedItem = options.filter(p => p.value === value)[0];
    onChange(selectedItem);
    setSelectedOption(selectedItem);
  };

  const extendedOptions = useMemo(
    (): IRadioGroupItemExtended[] =>
      options.map(option => ({
        ...option,
        id: `${option.value}-${Math.random().toString(10).slice(2)}`,
      })),
    [],
  );

  useEffect(() => {
    onChange(selectedOption);
  }, [selectedOption]);

  return (
    <>
      <RadioGroup
        value={selectedOption?.label}
        onChange={handleSelection}
      >
        {extendedOptions.map(option => (
          <FormControlLabel
            style={{ marginLeft: 8 }}
            key={option.id}
            value={option.value}
            control={<Radio />}
            label={option.label}
            disabled={disabled}
          />
        ))}
      </RadioGroup>
    </>
  );
};

export default RadioGroupComponent;
